import { useState } from "react";
import { Copy, RefreshCw } from "lucide-react";

import { useRestaurantContext } from "../../context/restaurant-context";
import { Button } from "../../components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "../../components/ui/card";
import { Input } from "../../components/ui/input";
import { toast } from "sonner";
import { TERMS } from "@tasty/shared";

export default function NoRestaurantPage() {
  const { authUser, fetchRestaurantByAdminSub } = useRestaurantContext();
  const [showSupportDetails, setShowSupportDetails] = useState(false);

  const email =
    typeof authUser?.attributes?.email === "string" ? authUser.attributes.email : "—";
  const sub =
    typeof authUser?.attributes?.sub === "string" ? authUser.attributes.sub : "—";

  const copy = async (value: string, label: string) => {
    try {
      await navigator.clipboard.writeText(value);
      toast.success(`${label} kopiert`);
    } catch {
      toast.error(`${label} konnte nicht kopiert werden`);
    }
  };

  return (
    <div className="mx-auto max-w-2xl space-y-6">
      <Card>
        <CardHeader>
          <CardTitle>Kein {TERMS.business} zugeordnet</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <p className="text-sm text-muted-foreground">
            Du bist eingeloggt, aber deinem Account ist aktuell kein {TERMS.business} zugeordnet.
            Das passiert typischerweise, wenn <code className="px-1">Restaurant.adminSub</code>{" "}
            noch nicht gesetzt ist.
          </p>

          <div className="rounded-lg border p-3 text-sm text-muted-foreground">
            Bitte melde dich beim Admin-Team, damit dein Account einmalig zugeordnet wird
            (<code className="px-1">Restaurant.adminSub</code> setzen).
          </div>
          <div className="flex gap-2">
            <Button variant="outline" onClick={() => fetchRestaurantByAdminSub()}>
              <RefreshCw className="mr-2 h-4 w-4" />
              Aktualisieren
            </Button>
            <Button
              variant="outline"
              onClick={() => setShowSupportDetails((v) => !v)}
            >
              {showSupportDetails ? "Support-Details ausblenden" : "Support-Details anzeigen"}
            </Button>
          </div>
          {showSupportDetails ? (
            <div className="grid gap-3">
              <div className="grid gap-2">
                <div className="text-sm font-medium">E-Mail (für Support)</div>
                <div className="flex gap-2">
                  <Input value={email} readOnly />
                  <Button
                    variant="outline"
                    onClick={() => copy(String(email), "E-Mail")}
                    disabled={email === "—"}
                  >
                    <Copy className="mr-2 h-4 w-4" />
                    Kopieren
                  </Button>
                </div>
              </div>
              <div className="grid gap-2">
                <div className="text-sm font-medium">Cognito Sub (adminSub)</div>
                <div className="flex gap-2">
                  <Input value={sub} readOnly />
                  <Button
                    variant="outline"
                    onClick={() => copy(String(sub), "Sub")}
                    disabled={sub === "—"}
                  >
                    <Copy className="mr-2 h-4 w-4" />
                    Kopieren
                  </Button>
                </div>
              </div>
            </div>
          ) : null}
        </CardContent>
      </Card>
    </div>
  );
}


